
const CommentSliderItemSlider = ({ data }) => {
    // console.log(props)

    return (
        <div className='item'>
            <div className="testimonial">
                <div className="image">
                    <img src={`https://amirsabit.4api.ir/uploads/Comments/${data.imagecustomer}`} title="" alt="" className="img-fluid" />
                </div>
                <p className="cm">
                    {data.summary}
                </p>
                <div className="author-info">
                    <div className="author-nm">{data.name}</div>
                    <div className="company">{data.subtitle}</div>
                    <div className="icon"><i className="far fa-quote-right"></i></div>
                </div>
            </div>
        </div>
    )
}
export default CommentSliderItemSlider;


// const CommentSliderItemSlider = ({ summary, name, subtitle, imagecustomer }) => {
//     // console.log(props)

//     return (
//         <div className='item'>
//             <div className="testimonial">
//                 <div className="image">
//                     <img src={`../img/${imagecustomer}`} title="" alt="" className="img-fluid" />
//                 </div>
//                 <p className="cm">
//                     {summary}
//                 </p>
//                 <div className="author-info">
//                     <div className="author-nm">{name}</div>
//                     <div className="company">{subtitle}</div>
//                     <div className="icon"><i className="far fa-quote-right"></i></div>
//                 </div>
//             </div>
//         </div>
//     )
// }
// export default CommentSliderItemSlider;